import React, { useState, useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { Drawer, DrawerContent, DrawerItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { authenticationService } from '../../services/authenticationService';
import { ScreenSize } from '../../app/ScreenSize';
import { GetScreenSize } from '../../app/GetScreenSize';
import { Skeleton } from "@progress/kendo-react-indicators";
import { Role } from '../../app/role';

import './DrawerRouterContainer.scss';

const DrawerContainer = (props) => {
    const currentUser = authenticationService.currentUserValue;

    const [pageTitle, setPageTitle] = useState("");
    const [drawerExpanded, setDrawerExpanded] = useState(true);
    const [items, setItems] = useState([]);
    const [data, setData] = useState([
        {},
        {},
        {},
        {},
        {},
        {},
    ]);
    const [isLoading, setIsLoading] = useState(true);

    const handleClick = () => {
        setDrawerExpanded(!drawerExpanded);
    };

    const onSelect = (ev) => {
        if ((ev.syntheticEvent.ctrlKey || ev.syntheticEvent.metaKey)
            && ev.itemTarget.props.route) {
            window.open(ev.itemTarget.props.route, "_blank");
            return;
        }

        const currentItem = ev.itemTarget.props;
        const isParent = currentItem.expanded !== undefined;
        const nextExpanded = !currentItem.expanded;
        const newItems = items.map((item) => {
            const {
                selected,
                expanded: currentExpanded,
                id,
                ...others
            } = item;

            const isCurrentItem = currentItem.id === id;

            return {
                selected: isCurrentItem,
                expanded: isCurrentItem && isParent ? nextExpanded : currentExpanded,
                id,
                ...others,
            };
        });

        if (ev.itemTarget.props.route) {
            props.history.push(ev.itemTarget.props.route);
        }

        setItems(newItems);
        convertItemsToDataAndSave(newItems);
    };

    const setNavigationItems = () => {
        if (!currentUser) {
            return;
        }

        let navItems = [];

        switch (currentUser.role) {
            case Role.Administrator:
                navItems = [
                    {
                        id: 1,
                        text: "Dashboard",
                        icon: "house-user",
                        selected: true,
                        route: "/administrator",
                    },
                    {
                        id: 2,
                        text: "My Login",
                        icon: "user",
                        route: "/administrator/mylogin",
                    },
                    {
                        separator: true,
                    },
                    {
                        id: 3,
                        text: "Reports",
                        icon: "file-csv",
                        expanded: false,
                    },
                    {
                        id: 100,
                        parentId: 3,
                        text: "Events Not Shorted",
                        icon: "k-i-minus",
                        route: "/administrator/report/eventsnotshorted",
                    },
                    {
                        id: 101,
                        parentId: 3,
                        text: "Events Missing POS Ids",
                        icon: "k-i-minus",
                        route: "/administrator/report/venueeventsmissingposeventid",
                    },
                    {
                        id: 102,
                        parentId: 3,
                        text: "Shorted Unmapped Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedunmappedevents",
                    },
                    {
                        id: 103,
                        parentId: 3,
                        text: "Shorted Unavailable Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedunavailableevents",
                    },
                    {
                        id: 104,
                        parentId: 3,
                        text: "Shorted Unbroadcasted Available Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedunbroadcastedavailableevents",
                    },
                    {
                        id: 105,
                        parentId: 3,
                        text: "Shorted Expensive Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedexpensiveevents",
                    },
                    {
                        id: 106,
                        parentId: 3,
                        text: "Shorted Low Margin Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedeventswithlowmargin",
                    },
                    {
                        id: 107,
                        parentId: 3,
                        text: "Shorted Events During Blackout Periods",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedeventsduringblackoutperiods",
                    },
                    {
                        id: 108,
                        parentId: 3,
                        text: "Shorted Events With Wrong On Hand Date",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedeventswithwrongonhanddate",
                    },
                    {
                        id: 109,
                        parentId: 3,
                        text: "Shorted Events Marked On Hand",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedeventsmarkedonhand",
                    },
                    {
                        id: 110,
                        parentId: 3,
                        text: "Shorted Inactive Alert Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myshortedinactivealertevents",
                    },
                    {
                        id: 111,
                        parentId: 3,
                        text: "Shorted Event Cost Comparisons",
                        icon: "k-i-minus",
                        route: "/administrator/report/shortedeventcostcomparisons",
                    },
                    {
                        id: 112,
                        parentId: 3,
                        text: "Temporarily Hidden Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/mytemporarilyhiddenevents",
                    },
                    {
                        id: 113,
                        parentId: 3,
                        text: "Hidden Events",
                        icon: "k-i-minus",
                        route: "/administrator/report/myhiddenevents",
                    },
                    {
                        id: 114,
                        parentId: 3,
                        text: "Event Alerts",
                        icon: "k-i-minus",
                        route: "/administrator/report/venueeventalerts",
                    },
                    {
                        id: 115,
                        parentId: 3,
                        text: "Venue Shorting Statuses",
                        icon: "k-i-minus",
                        route: "/administrator/venueshortingstatuses",
                    },
                    {
                        id: 116,
                        parentId: 3,
                        text: "Events Missing Data",
                        icon: "k-i-minus",
                        route: "/administrator/report/venueeventsmissingdata",
                    },
                    {
                        id: 117,
                        parentId: 3,
                        text: "Triggered Event Alerts",
                        icon: "k-i-minus",
                        route: "/administrator/report/triggeredvenueeventalerts",
                    },
                    {
                        id: 118,
                        parentId: 3,
                        text: "Event Status Changes",
                        icon: "k-i-minus",
                        route: "/administrator/report/venueeventstatuschanges",
                    },
                    {
                        id: 119,
                        parentId: 3,
                        text: "TWAs Not Run Recently",
                        icon: "k-i-minus",
                        route: "/administrator/report/ticketingwebsitealertsnotrunrecently",
                    },
                    {
                        id: 120,
                        parentId: 3,
                        text: "Force Run TWAs",
                        icon: "k-i-minus",
                        route: "/administrator/report/forcerunticketingwebsitealerts",
                    },
                    {
                        id: 121,
                        parentId: 3,
                        text: "TWA Issues",
                        icon: "k-i-minus",
                        route: "/administrator/report/ticketingwebsitealertissues",
                    },
                    {
                        id: 122,
                        parentId: 3,
                        text: "Event Alert Issues",
                        icon: "k-i-minus",
                        route: "/administrator/report/venueeventalertissues",
                    },
                    {
                        id: 123,
                        parentId: 3,
                        text: "GA Ticket Types",
                        icon: "k-i-minus",
                        route: "/administrator/report/generaladmissionvenueeventtickettypes",
                    },
                    {
                        id: 124,
                        parentId: 3,
                        text: "Mark Orders As Paid",
                        icon: "k-i-minus",
                        route: "/administrator/report/markordersaspaid",
                    },
                    {
                        separator: true,
                    },
                    {
                        id: 4,
                        text: "Website Alerts",
                        icon: "calendar-days",
                        route: "/administrator/ticketingwebsitealerts",
                    },
                    {
                        separator: true,
                    },
                    {
                        id: 5,
                        text: "Events",
                        icon: "microphone",
                        route: "/administrator/venueevents",
                    },
                    {
                        id: 6,
                        text: "Venues",
                        icon: "landmark",
                        route: "/administrator/venues",
                    },
                    {
                        id: 7,
                        text: "Performers",
                        icon: "users",
                        route: "/administrator/performers",
                    },
                    {
                        separator: true,
                    },
                    {
                        id: 8,
                        text: "System",
                        icon: "cog",
                        expanded: false,
                    },
                    {
                        id: 150,
                        parentId: 8,
                        text: "System Settings",
                        icon: "k-i-minus",
                        route: "/administrator/systemsettings",
                    },
                    {
                        id: 151,
                        parentId: 8,
                        text: "Proxy Servers",
                        icon: "k-i-minus",
                        route: "/administrator/proxyservers",
                    },
                    {
                        id: 152,
                        parentId: 8,
                        text: "User Agents",
                        icon: "k-i-minus",
                        route: "/administrator/useragents",
                    },
                    {
                        id: 153,
                        parentId: 8,
                        text: "Logins",
                        icon: "k-i-minus",
                        route: "/administrator/logins",
                    },
                    {
                        id: 154,
                        parentId: 8,
                        text: "Regions",
                        icon: "k-i-minus",
                        route: "/administrator/regions",
                    },
                    {
                        id: 155,
                        parentId: 8,
                        text: "Ticketing Websites",
                        icon: "k-i-minus",
                        route: "/administrator/ticketingwebsites",
                    },
                    {
                        id: 156,
                        parentId: 8,
                        text: "Secondary Ticketing Websites",
                        icon: "k-i-minus",
                        route: "/administrator/secondaryticketingwebsites",
                    },
                    {
                        id: 157,
                        parentId: 8,
                        text: "Min Age POS Notes",
                        icon: "k-i-minus",
                        route: "/administrator/minimumageposnotes",
                    },
                    {
                        id: 158,
                        parentId: 8,
                        text: "TW POS Customers",
                        icon: "k-i-minus",
                        route: "/administrator/ticketingwebsiteposcustomers",
                    },
                    {
                        separator: true,
                    },
                    {
                        id: 99,
                        text: "Log Out",
                        icon: "sign-out-alt",
                        route: "/logout",
                    },
                ];
                break;

            case Role.User:
                navItems = [
                    {
                        id: 1,
                        text: "Dashboard",
                        icon: "house-user",
                        selected: true,
                        route: "/user",
                    },
                    {
                        id: 2,
                        text: "My Login",
                        icon: "user",
                        route: "/user/mylogin",
                    },
                    {
                        separator: true,
                    },
                    {
                        id: 99,
                        text: "Log Out",
                        icon: "sign-out-alt",
                        route: "/logout",
                    },
                ];
                break;

            default:
                //Unknown scenario
                break;
        }
      
        setItems(navItems);
        convertItemsToDataAndSave(navItems);
        setIsLoading(false);
    }

    const convertItemsToDataAndSave = (localItems) => {
        localItems = localItems.map((item) => {
            const { parentId, ...others } = item;

            if (parentId !== undefined) {
                const parent = localItems.find((parent) => parent.id === parentId);
                const visible = !parent || parent.expanded === undefined || parent.expanded === true;
                return { ...others, visible: visible };
            }

            return item;
        });

        setData(localItems);
    }

    const getIcon = (iconName) => {
        if (!iconName) {
            return <></>;
        }

        if (String(iconName).startsWith("k-i")) {
            return (
                <span className={"k-icon " + iconName} />
            );
        }

        return (
            <FontAwesomeIcon icon={iconName} className="k-icon" fixedWidth />
        );
    }

    const CustomItem = (props) => {
        const { visible, ...others } = props;
        const arrowDir = props["expanded"]
            ? "k-i-arrow-chevron-down"
            : "k-i-arrow-chevron-right";

        return (
            <>
                {props.visible === false ? null : (
                    isLoading === true ? 
                        <li className="k-drawer-item">
                            <Skeleton shape={"circle"} />   
                            <Skeleton shape={"text"} />                      
                        </li>
                    :
                    (
                        (props.route?.startsWith("http") && props.separator === false) ?
                            <li className="k-drawer-item" role="option" aria-selected="false" tabindex="0" id={props.id}>
                                <a href={props.route} rel="noreferrer" target={props.openInNewWindow === true ? "_blank" : "_self"}>
                                    {getIcon(props.icon)}
                                    <span class="k-item-text" title={props.text}>{props.text}</span>
                                </a>
                            </li>
                        :
                        <DrawerItem {...others}>
                            {getIcon(props.icon)}
                    
                            <span className={"k-item-text"} title={props.text}>{props.text}</span>
                            
                            {props["expanded"] !== undefined && (
                                <span
                                    className={"k-icon " + arrowDir}
                                />
                            )}
                        </DrawerItem>
                    )
                )}
            </>
        );
    };

    const GetRedirect = () => {
        const path = window.location.pathname.toLowerCase();
        
        let requiresUserToBeLoggedIn;
        switch (path) {
            case "/login":
            case "/loginwithtoken":
            case "/logout":
            case "/forgotpassword":
            case "/privacy":
                requiresUserToBeLoggedIn = false;
                break;

            default:
                if (path.startsWith("/resetpassword/")) {
                    requiresUserToBeLoggedIn = false;
                }
                else {
                    requiresUserToBeLoggedIn = true;
                }
                break;
        }

        if (requiresUserToBeLoggedIn) {
            return (
                <Redirect to={{ pathname: '/login', state: { from: window.location.pathname } }} />
            );
        }
        else {
            return (
                <></>
            );
        }
    };

    useEffect(() => {
        setNavigationItems();
    }, []);

    useEffect(() => {       
        const baseTitle = "OTT";

        if (baseTitle !== document.title && (baseTitle === "" || document.title.indexOf(baseTitle) === -1)) {
            setPageTitle(document.title);

            if (baseTitle !== "") {
                document.title = `${document.title} | ${baseTitle}`;
            }
        }
    }, [props]);

    return (
        <>
            {!currentUser
                ? GetRedirect()
                :
                <div>
                    <div className="custom-toolbar">
                        <Button icon="menu" fillMode="flat" onClick={handleClick} aria-label="Menu" title="Menu" />
                        <span className="title d-none d-sm-inline">
                            {pageTitle}
                        </span>
                    </div>
                    <Drawer
                        expanded={drawerExpanded}
                        mode={GetScreenSize() === ScreenSize.Desktop ? "push" : "overlay"}
                        items={data}
                        item={CustomItem}
                        onSelect={onSelect}
                        onOverlayClick={() => setDrawerExpanded(false)}
                    >
                        <DrawerContent>{props.children}</DrawerContent>
                    </Drawer>            
                </div>
            }
        </>
    );
};

export default withRouter(DrawerContainer);